import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { skuFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/skus';

import { defaultValues } from './model';

export function useFormDefinition(v = defaultValues) {
  return useForm({
    resolver: zodResolver(skuFormSchema),
    defaultValues: v,
  });
}

export type UseFormDef = ReturnType<typeof useFormDefinition>;
